/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HomeHealthCertificationExtractionStatus } from './HomeHealthCertificationExtractionStatus';
import {
    HomeHealthCertificationExtractionStatusFromJSON,
    HomeHealthCertificationExtractionStatusFromJSONTyped,
    HomeHealthCertificationExtractionStatusToJSON,
    HomeHealthCertificationExtractionStatusToJSONTyped,
} from './HomeHealthCertificationExtractionStatus';
import type { HomeHealthCertification } from './HomeHealthCertification';
import {
    HomeHealthCertificationFromJSON,
    HomeHealthCertificationFromJSONTyped,
    HomeHealthCertificationToJSON,
    HomeHealthCertificationToJSONTyped,
} from './HomeHealthCertification';

/**
 * 
 * @export
 * @interface HomeHealthCertificationResult
 */
export interface HomeHealthCertificationResult {
    /**
     * 
     */
    status: HomeHealthCertificationExtractionStatus;
    /**
     * 
     */
    result: HomeHealthCertification;
}



/**
 * Check if a given object implements the HomeHealthCertificationResult interface.
 */
export function instanceOfHomeHealthCertificationResult(value: object): value is HomeHealthCertificationResult {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('result' in value) || value['result'] === undefined) return false;
    return true;
}

export function HomeHealthCertificationResultFromJSON(json: any): HomeHealthCertificationResult {
    return HomeHealthCertificationResultFromJSONTyped(json, false);
}

export function HomeHealthCertificationResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeHealthCertificationResult {
    if (json == null) {
        return json;
    }
    return {
        
        'status': HomeHealthCertificationExtractionStatusFromJSON(json['status']),
        'result': HomeHealthCertificationFromJSON(json['result']),
    };
}

export function HomeHealthCertificationResultToJSON(json: any): HomeHealthCertificationResult {
    return HomeHealthCertificationResultToJSONTyped(json, false);
}

export function HomeHealthCertificationResultToJSONTyped(value?: HomeHealthCertificationResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': HomeHealthCertificationExtractionStatusToJSON(value['status']),
        'result': HomeHealthCertificationToJSON(value['result']),
    };
}

